import { map, Observable, switchMap } from 'rxjs'
import { fromFetch } from 'rxjs/internal/observable/dom/fetch'
import { switchMapRight } from '../rx/operators'
import { fetchResponseToJsonResult, fetchResponseToVoidResult, headers } from '../fetch'
import { CustomError } from '../fetch/errors'

export interface FilesCreateUploadUrl {
  uploadUrl: string
  uploadedFileUrl: string
}

const merciUrl = process.env.GATSBY_MERCI_URL || 'https://merci.api.dfh.dev'

export const fromAssetCreateRequest = (
  body: File
): Observable<
  { _tag: 'Left'; error: CustomError | Error } | { _tag: 'Right'; data: FilesCreateUploadUrl }
> =>
  fromFetch(`${merciUrl}/files/upload-url`, {
    body: JSON.stringify({
      name: body.name,
    }),
    method: 'POST',
    headers: {
      ...headers.acceptJson,
      ...headers.contentTypeJson,
    },
  }).pipe(
    switchMap((response) => fetchResponseToJsonResult<FilesCreateUploadUrl>(response)),
    switchMapRight((result) =>
      fromFetch(result.data.uploadUrl, {
        body: body,
        method: 'PUT',
        headers: {
          ...headers.acceptJson,
          ...headers.contentType(body.type),
        },
      }).pipe(
        switchMap((response) => fetchResponseToVoidResult(response)),
        map(() => result)
      )
    )
  )
